<dx-speed-dial-action *ngFor="let action of actions.concat(additionalActions); let index = index"
  [icon]="action?.icon"
  [label]="action?.label"
  [index]="index"
  [visible]="getVisibility(action)"
  (onClick)="executeAction(action)"
>
</dx-speed-dial-action>
